<div class="sh-page-header">
  <header class="sh-page-header__head">
    <div class="sh-page-header__head__info">
      <h3 class="sh-page-title--subsection">
        <svg sh-icon class="sh-icon-title__icon" aria-hidden="true" [name]="icon"></svg>
        {{ title }}
      </h3>
    </div>
    <div class="sh-page-header__head__actions">
      <a [shNavigationLink]="navigationLink" class="sh-link sh-icon-link sh-truncate-text">
        {{ "dashboard.show-all" | translate }}
        @if (totalItems > 0) {
          <span class="sh-badge--update sh-icon-link__icon">{{ totalItems }}</span>
        }
        <svg sh-icon class="sh-icon--small sh-icon-link__icon" [name]="'arrow-right'"></svg>
      </a>
    </div>
  </header>
</div>
